import { render, staticRenderFns } from "./importEntity.vue?vue&type=template&id=773980f6&scoped=true"
import script from "./importEntity.vue?vue&type=script&lang=js"
export * from "./importEntity.vue?vue&type=script&lang=js"
import style0 from "./importEntity.vue?vue&type=style&index=0&id=773980f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773980f6",
  null
  
)

export default component.exports